import { getBanner, IMGClick, getBannerCMS } from "api/banner";
import { ERR_OK } from "api/config";

export default {
  getBannerList() {
    let url = window.location.pathname;
    var pageName = 1;
    if (url == "/index") {
      pageName = 1;
      // } else if (url == '/project') { idh重构
    } else if (url == "/projectNew") {
      pageName = 3;
    } else if (url == "/comp/index") {
      pageName = 6;
    } else if (url == "/cad") {
      pageName = 4;
    } else if (url == "/ees") {
      pageName = 5;
    }
    let param = {
      protNum: 1, // 0:pcd端 1： 移动端
      pageName: pageName // 0:全局 1: 首页 2：idm 3：方案设计 4：高速pcb设计 5：ees 6：bom 7：登录 8：注册
    };
    return getBanner(param)
      .then(res => {
        if (res.code != ERR_OK) {
          return Promise.reject(res);
        }
        if (res.result) {
          return res.result;
        }
      })
      .catch(erro => {
        if (!erro.isCancel) {
          this.$toast(erro.message);
        }
      })
      .finally(() => {});
  },
  // 新版cms图片管理banner  idh 页面
  getBannerNew(categoryName) {
    let categoryId = "";
    // if (categoryName == "index") {
    //   categoryId = 95;
    // } else if (categoryName == "projectNew") {
    //   categoryId = 69;
    // } else if (categoryName == "cad") {
    //   categoryId = 96;
    // } else if (categoryName == "ees") {
    //   categoryId = 98;
    // }
    // let param = {
    //   cmd: 3,
    //   categoryId: categoryId,
    //   // showUrl: 'https://eeidm.com/view/projectNew.html',
    //   port: "WAP" // 1:pcd端 2： 移动端
    //   // pageName: pageName // 0:全局 1: 首页 2：idm 3：方案设计 4：高速pcb设计 5：ees 6：bom 7：登录 8：注册
    // };
    if (categoryName == "index") {
      categoryId = 163;
    } else if (categoryName == "projectNew") {
      categoryId = 160;
    } else if (categoryName == "cad") {
      categoryId = 161;
    } else if (categoryName == "ees") {
      categoryId = 162;
    }
    let param = {
      pageNumber: 1,
      pageSize: 20,
      categoryId,
      status: 1,
      channelId: 1,
      port: "WAP"
    };
    console.log(999);
    return getBannerCMS(param)
      .then(res => {
        console.log(2222, "res");
        if (res.code != ERR_OK) {
          return Promise.reject(res);
        }
        if (res.rows) {
          return res.rows;
        }
      })
      .catch(erro => {
        console.log(erro, "erro");
        if (!erro.isCancel) {
          this.$toast(erro.message);
        }
      })
      .finally(() => {});
  },
  getAllImg() {
    let param = {
      protNum: 1, // 0:pcd端 1： 移动端
      pageName: 0 // 0:全局 1: 首页 2：idm 3：方案设计 4：高速pcb设计 5：ees 6：bom 7：登录 8：注册
    };
    return getBanner(param)
      .then(res => {
        if (res.code != ERR_OK) {
          return Promise.reject(res);
        }
        // console.log(res, 'newresssssssssssssss----')
        if (res.result) {
          // this.setTime(res.result)
          return res.result;
        }
      })
      .catch(erro => {
        if (!erro.isCancel) {
          this.$toast(erro.message);
        }
      })
      .finally(() => {});
  },
  clickImg(id) {
    let param = {
      ID: id
    };
    return IMGClick(param)
      .then(res => {
        if (res.code != ERR_OK) {
          return Promise.reject(res);
        }
        if (res.result) {
        }
      })
      .catch(erro => {
        if (!erro.isCancel) {
          this.$toast(erro.message);
        }
      })
      .finally(() => {});
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/public.js